module.exports = __webpack_public_path__ + "assets/img/logoText.b6bb9e16.png";